import React, { Fragment } from 'react';
import ReactQuill from 'react-quill';
import { Col, Form, Label, Input } from 'reactstrap';
import 'react-quill/dist/quill.snow.css';
import { connect } from "react-redux";
import { fetchProgramDetails , addProgramDetails} from 'Actions';
import { NotificationManager } from 'react-notifications';
import CircularProgress from '@mui/material/CircularProgress';


// intl messages
import IntlMessages from 'Util/IntlMessages';
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

const modules = {
  toolbar: [
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    [{ 'font': [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
    ['link', 'image'],
    ['clean'],
    [{ 'align': [] }],
    ['code-block']
  ],
};

const formats = [
  'header',
  'font',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent',
  'link', 'image', 'align',
  'code-block'
];

class AddPrograms extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cpfDesc: '',
      selecttype:'',
      //agreement: this.props.particularcontractstudent.program[0].ctpi_student_agreement_id,
      edagreement:this.props.data.edagreement,
      loader:false,
    };
    
  }
 

  handleFormSubmit = (e) => {
    e.preventDefault();
    this.setState({loader:true });
    const { selecttype, cpfDesc, edagreement } = this.state; 
    const desc = cpfDesc;
    if(selecttype==""){
       NotificationManager.error("please select the program");
       this.setState({loader:false }); 
    }else{
        this.props.addProgramDetails(selecttype, desc, edagreement) 
        .then((response) => {    
          this.setState({loader:false });   
          this.props.onClick();
          
        });
    }
  };

  
  

  handleOptionChange = (e) => {
    const selectedOption = e.target.value;
    this.setState({ selecttype:selectedOption  });
    this.props.fetchProgramDetails(selectedOption).then((response) => {
    
      if (response) {
        
        const cpfDesc = response.data[0].cpf_desc;
        this.setState({ cpfDesc });
      }
    });
  };

  render() {
    const { allgolfprogram, loading} = this.props; 
    const { cpfDesc } = this.state;
    const styles = {
      buttonProgress: {
          color: "blue",
          position: 'absolute',
          top: '65%',
          left: '50%',
          marginTop: -15,
          marginLeft: -15,
      },
      wrapper: {
          position: 'relative',
          textAlign:"center"
      },
  };
    return (
      <>
        <div className="row gx-3">
          <div className="col-sm-12 col-lg-12 ">
            <RctCollapsibleCard
              heading={
                <div style={{ display: 'flex', alignItems: 'center', borderBottom: "1px solid #ccc" }}>
                  <span>Programs</span>
                  {/* <button type="button" className="mr-3 mb-3 btn btn-outline-warning ml-auto" onClick={this.props.onClick}>Back</button> */}
                </div>
              }
            >
              <div className="form-group row">
                <label className="col-sm-2 col-form-label">Select Program:</label>
                <div className="col-sm-4">
                  <select className="form-control" name="agreementtype" id="agreementtype" required value={this.state.selecttype} onChange={this.handleOptionChange}>
                    <option value="">Select</option>
                    {allgolfprogram.map((p, index) => (
                         <option value={p.id}>{p.name}</option>
                    ))}  
                    
                  </select>
                </div>
              </div>
              <Fragment>
                <div className="form-group row">
                  <label className="col-sm-2 col-form-label">Program Details:</label>
                  <div className="col-sm-12">
                    <ReactQuill modules={modules} formats={formats} value={cpfDesc} onChange={(value) => this.setState({ cpfDesc: value })} />
                  </div>
                </div>
              </Fragment>
              <div className="form-group" style={styles.wrapper}> 
              <button type="button" className="mr-3 mb-3 btn btn-outline-primary btncenter" disabled={this.state.loader} style={{ margin: "0 auto", marginTop: "20px" }} onClick={this.handleFormSubmit}>Submit</button>
                {this.state.loader && <CircularProgress size={24} style={styles.buttonProgress} />}    
              </div>
              {/* <input type="submit" className="btn btn-outline-primary btncenter" value="Submit" style={{ display: "block", margin: "0 auto", marginTop: "20px" }} onClick={this.handleFormSubmit} /> */}
            </RctCollapsibleCard>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ contractstudent }) => {
  const { particularcontractstudent, travelformmail, allgolfprogram, loading } = contractstudent;
  return { particularcontractstudent, travelformmail, allgolfprogram, loading };
};

export default connect(mapStateToProps, {
  fetchProgramDetails,
  addProgramDetails
})(AddPrograms);
